import { useEffect } from 'react';
import _refiner from 'refiner-js';
import { useCurrentLanguage } from '~hooks/language';

const REFINER_APP_KEY = import.meta.env.VITE_REFINER_PROJECT_ID;

function useProductSurveys() {
  const enabled = REFINER_APP_KEY != null;
  const currentLanguage = useCurrentLanguage();

  const initialise = async (userReferenceId: string, customer: string) => {
    _refiner('setProject', [REFINER_APP_KEY]);
    _refiner('setOptions', {
      trackPageViews: false,
      captureErrors: false,
    });
    _refiner('identifyUser', {
      id: userReferenceId,
      customer: customer,
      appName: 'health_dashboard',
    });
  };

  useEffect(() => {
    if (currentLanguage) {
      _refiner('setLocale', currentLanguage);
    }
  }, [currentLanguage]);

  const triggerSurvey = async (name: string) => {
    _refiner('trackEvent', name);
  };

  return {
    productSurveysEnabled: enabled,
    initialiseProductSurveys: initialise,
    triggerSurvey,
  };
}

export default useProductSurveys;
